import { useEffect, useState } from "react";
import "./styles.css";

import icon from "../../assets/iconwhats.png";

const CtaWpp = (props) => {
  const [text, setText] = useState("Solicitar orçamento");

  useEffect(() => {
    if (props.text !== undefined) setText(props.text);
  }, []);

  return (
    <button id="ctaWpp">
      <a
        href="http://wa.me/+5511994858068?text=Solicitar%20Orçamento"
        target="_blank"
        rel="noreferrer"
      >
        <figure>
          <img src={icon} alt="Ícone do Whatsapp" />
        </figure>
        <p>{text}</p>
      </a>
    </button>
  );
};

export default CtaWpp;
